// extracted by mini-css-extract-plugin
export default {"login-with-google-btn":"GoogleSignIn_login-with-google-btn__BrWL4"};